import React from "react";
import CounterContext from "./context/context";
import CounterWrapper from "./ui/CounterWrapper";

export default function Counter() {
	return (
		<CounterContext>
			<CounterWrapper />
		</CounterContext>
	);
}
